import { useSyncExternalStore } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'
const STORE_KEY = Symbol.for('@alternative/acqua/reduced-motion')

function createStore() {
  let mediaQuery: MediaQueryList | undefined
  const listeners = new Set<() => void>()
  const getMediaQuery = () => (mediaQuery ??= window.matchMedia(QUERY))
  const notify = () => listeners.forEach(listener => listener())

  return {
    getSnapshot: () => getMediaQuery().matches,
    subscribe: (listener: () => void) => {
      const query = getMediaQuery()
      if (listeners.size === 0) query.addEventListener('change', notify)
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
        if (listeners.size === 0) {
          query.removeEventListener('change', notify)
          mediaQuery = undefined
        }
      }
    }
  }
}

function getStore() {
  // The package builds self-contained entry points. A browser-scoped symbol
  // shares the observer across root/atoms imports without touching SSR globals.
  const owner = window as Window & {
    [STORE_KEY]?: ReturnType<typeof createStore>
  }
  return (owner[STORE_KEY] ??= createStore())
}

const subscribe = (listener: () => void) => getStore().subscribe(listener)
const getSnapshot = () => getStore().getSnapshot()
// Match the existing server markup during hydration, then read the preference.
const getServerSnapshot = () => false

export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
